const initGorgiasChatPromise = window.GorgiasChat
  ? window.GorgiasChat.init()
  : new Promise(function (resolve) {
      window.addEventListener('gorgias-widget-loaded', function () {
        resolve()
      })
    })

initGorgiasChatPromise.then(() => {
  const gorgiasButton = document.querySelector('.js-gorigas-open')
  gorgiasButton &&
    gorgiasButton.addEventListener('click', function () {
      if (GorgiasChat.isOpen()) {
        GorgiasChat.close()
      } else {
        GorgiasChat.open()
      }
    })
})
